import React,{useState, useEffect} from "react";
import sendicon from './../../../images/sendmoneyicon.png'
import receiveicon from './../../../images/receivemoneyicon.png'
import receivepaymenticon from './../../../images/receivepaymenticon.png'
import sendpaymenticon from './../../../images/sendpaymenticon.png'
import banktransfericon from './../../../images/banktransfericon.png'
import paymentinfoicon from './../../../images/paymentinfobtn.png'
import walletgraph from './../../../images/walletbars.png'
import walletcomingsoon from './../../../images/walletcomingsoon.png'
import moreoptionsbtn from './../../../images/moreoptionbtn.png'
import Royalties from "./../../PostLogin/Dashboard/Wallet/Royalties";
import Statements from "./../../PostLogin/Dashboard/Wallet/Statements";
import Wallet from "./../../PostLogin/Dashboard/Wallet/Wallet";
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import {Route,Routes, Redirect, Navigate} from 'react-router-dom'
import {useLocation,useNavigate} from "react-router-dom";
import Products from "./Products";
import Assets from "./Assets";
import Artists from "./Artists";
import People from "./People";
import Publishers from "./Publishers";
import Labels from "./Labels";
 
function Catalog({hidedashboard,nav}) {
    
  
    const {t, i18n } = useTranslation();
    const [option,setOption] = useState(1)
    const cookies = new Cookies(null ,{ path: '/' });
    const [walletEmpty,setWalletEmpty] = useState(true)
    const navigate = useNavigate();
    const location = useLocation();


    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    
    useEffect(()=>{
        topFunction()
        hidedashboard(true)
        nav("Catalog")
        if(cookies.get("artistname").length!==0){
            setWalletEmpty(false)
        }

       
    },[])

    useEffect(()=>{
        if(location.pathname==="/dashboard/label/catalog" || location.pathname==="/dashboard/label/catalog/"){
            setOption(1)
          }
          if(location.pathname==="/dashboard/label/catalog/assets"){
            setOption(2)
          }
      
          if(location.pathname==="/dashboard/label/catalog/artists"){
            setOption(3)
          }

          if(location.pathname==="/dashboard/label/catalog/people"){
            setOption(4)
          }

          if(location.pathname==="/dashboard/label/catalog/publishers"){
            setOption(5)
          }

          if(location.pathname==="/dashboard/label/catalog/labels"){
            setOption(6)
          }
    },[location.pathname])




 

    return (
        <div  className="PYContainer">
        

        <div className="WalletContainer" style={{paddingBottom:'5em'}}>
                <div className="WalletHeaderTxt">
                 CATALOG
                </div>

                <div style={{display:'flex',flexDirection:'row', borderBottom:'1px #595959 solid',marginLeft:'0em',width:'95.28%',marginTop:'2em'}}>
                    {
                       option !== 1 &&
                        <div>
                            <div className="MoneyDrawerHeading" onClick={()=>{setOption(1);navigate('/dashboard/label/catalog')}} style={{cursor:'pointer'}}>PRODUCTS</div>
                        </div>
                    }
    
                    {
                       option === 1 &&
                        <div>
                            <div className="MoneyDrawerHeadingSelected">PRODUCTS</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }
    
                    {
                       option !== 2 &&
                        <div>
                            <div className="MoneyDrawerHeading" onClick={()=>{setOption(2);navigate('/dashboard/label/catalog/assets')}} style={{cursor:'pointer'}}>ASSETS</div>
                        </div>
                    }
    
                    {
                       option === 2 &&
                        <div>
                            <div className="MoneyDrawerHeadingSelected">ASSETS</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }
    
                    {
                       option !== 3 &&
                        <div>
                            <div className="MoneyDrawerHeading" onClick={()=>{setOption(3);navigate('/dashboard/label/catalog/artists')}} style={{cursor:'pointer'}}>ARTISTS</div>
                        </div>
                    }
    
                    {
                       option === 3 &&
                        <div>
                            <div className="MoneyDrawerHeadingSelected">ARTISTS</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }

                    {
                       option !== 4 &&
                        <div>
                            <div className="MoneyDrawerHeading" onClick={()=>{setOption(4);navigate('/dashboard/label/catalog/people')}} style={{cursor:'pointer'}}>PEOPLE</div>
                        </div>
                    }
    
                    {
                       option === 4 &&
                        <div>
                            <div className="MoneyDrawerHeadingSelected">PEOPLE</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }

                    {
                       option !== 5 &&
                        <div>
                            <div className="MoneyDrawerHeading" onClick={()=>{setOption(5);navigate('/dashboard/label/catalog/publishers')}} style={{cursor:'pointer'}}>PUBLISHERS</div>
                        </div>
                    }
    
                    {
                       option === 5 &&
                        <div>
                            <div className="MoneyDrawerHeadingSelected">PUBLISHERS</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }

                    {
                       option !== 6 &&
                        <div>
                            <div className="MoneyDrawerHeading" onClick={()=>{setOption(6);navigate('/dashboard/label/catalog/labels')}} style={{cursor:'pointer'}}>LABELS</div>
                        </div>
                    }
    
                    {
                       option === 6 &&
                        <div>
                            <div className="MoneyDrawerHeadingSelected">LABELS</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }
    
    
                  
            
                </div>

                <div style={{width:'95.28%',marginTop:'1.5em'}}>
                    {
                        option === 1 &&
                        <Routes>
                            <Route exact path="/" element={<Products nav={nav}/>}/>
                        </Routes>
                    }

                    {
                        option === 2 &&
                        <Routes>
                            <Route exact path="/assets" element={<Assets nav={nav}/>}/>
                         </Routes>
                    }

                    {
                        option === 3 &&
                        <Routes>
                            <Route exact path="/artists" element={<Artists nav={nav}/>}/>
                         </Routes>
                    }

                    {
                        option === 4 &&
                        <Routes>
                            <Route exact path="/people" element={<People nav={nav}/>}/>
                         </Routes>
                    }

                    {
                        option === 5 &&
                        <Routes>
                            <Route exact path="/publishers" element={<Publishers nav={nav}/>}/>
                         </Routes>
                    }

                    {
                        option === 6 &&
                        <Routes>
                            <Route exact path="/labels" element={<Labels nav={nav}/>}/>
                         </Routes>
                    }


                </div>
            </div>
        
        </div>
       
    );
}

export default Catalog;